//  Common and utm are the form fields that will be required for Marketo Submission
//  They correspond to the name attribute of the input element

export const FirstName = "FirstName";
export const LastName = "LastName";
export const Email = "Email";
export const Phone = "Phone";
export const thankYou = "thankYou";
export const Company = "Company";
export const commentCapture = "commentCapture";
export const utm_source = "utm_source";
export const utm_medium = "utm_medium";
export const utm_campaign = "utm_campaign";
export const utm_content = "utm_content";
export const utm_term = "utm_term";
export const Event_Date__c = "Event_Date__c";
export const Number_of_Attendees__c = "Number_of_Attendees__c";
export const eventType = "eventType";
export const isyoureventopentoIndustriousMembers =
  "isyoureventopentoIndustriousMembers";
export const Select_Location__c = "Select_Location__c";
export const Latest_Application_Toured_Location_ID__c =
  "Latest_Application_Toured_Location_ID__c";
export const Building_Info__c = "Building_Info__c";
export const Comments_from_application__c = "Comments_from_application__c";
export const Contact_Type__c = "Contact_Type__c";
export const Office_Size2__c = "Office_Size2__c";
export const Reference_Code__c = "Reference_Code__c";
export const Target_Location_ID__c = "Target_Location_ID__c";
export const marketingEmailOptIn = "marketingEmailOptIn";
export const NumberOfEmployees = "NumberOfEmployees";
export const City = "City";
export const Partnerize_Conversion_ID_App__c =
  "Partnerize_Conversion_ID_App__c";
export const last_referral_url__c = "last_referral_url__c";
("Partnerize_Conversion_ID_App__c");

export const commonInterface = [
  FirstName,
  LastName,
  Email,
  Phone,
  Company,
  commentCapture,
  thankYou,
];

export const utmInterface = [
  utm_source,
  utm_medium,
  utm_campaign,
  utm_content,
  utm_term,
];

//  Select_Location__c and Latest_Application_Toured_Location_ID__c are not form fields
//  appended through appendLocation function from marketoUtil
export const eventSpaceForm = [
  Event_Date__c,
  Number_of_Attendees__c,
  eventType,
  isyoureventopentoIndustriousMembers,
  Select_Location__c,
  Latest_Application_Toured_Location_ID__c,
];

//  Comments_from_application__c and Contact_Type__c are set by appendLandlord
export const landlordForm = [
  Building_Info__c,
  Comments_from_application__c,
  Contact_Type__c,
];

export const bookTourForm = [
  Latest_Application_Toured_Location_ID__c,
  Select_Location__c,
  Office_Size2__c,
  Reference_Code__c,
  marketingEmailOptIn,
];

export const getStarted = [
  Latest_Application_Toured_Location_ID__c,
  Select_Location__c,
  marketingEmailOptIn,
];

export const Q42021Reengagement = [
  Latest_Application_Toured_Location_ID__c,
  Select_Location__c,
  marketingEmailOptIn,
];
export const Corenet_Form = [
  Latest_Application_Toured_Location_ID__c,
  Select_Location__c,
  marketingEmailOptIn,
];

export const LandLordVip_Form = [
  marketingEmailOptIn,
  Target_Location_ID__c,
  NumberOfEmployees,
  last_referral_url__c,
];

export const brokerForm = [Target_Location_ID__c, marketingEmailOptIn];

export const newsLetterForm = [Target_Location_ID__c, Select_Location__c];

export const resourceForm = [Target_Location_ID__c, marketingEmailOptIn];
